"use client";

import { isServer } from "@/lib/utils";
import { initializePylon } from "@/lib/pylon";
import { useUserStore } from "@/providers/UserStoreProvider";
import { useRef } from "react";
import { useShallow } from "zustand/react/shallow";

export const PylonProvider = ({ children }: { children: React.ReactNode }) => {
  const isInitialized = useRef(false);
  const appId = process.env.NEXT_PUBLIC_PYLON_APP_ID!;

  const { userEmail, userName, avatarUrl, pylonHashedEmail, userId } = useUserStore(
    useShallow(state => ({
      userId: state.id,
      userEmail: state.email,
      userName: state.getFullName(),
      avatarUrl: state.avatar,
      pylonHashedEmail: state.pylonHashedEmail,
    }))
  );

  if (!isInitialized.current && !isServer()) {
    initializePylon(appId);
    isInitialized.current = true;
    // @ts-ignore - external script
    window.pylon = {
      chat_settings: {
        app_id: appId,
        email: userEmail,
        name: userName,
        avatar_url: avatarUrl,
        email_hash: pylonHashedEmail,
        account_id: userId,
      },
    };
  }

  return <>{children}</>;
};
